import { render, staticRenderFns } from "./personnelManagement.vue?vue&type=template&id=25c87512"
import script from "./personnelManagement.vue?vue&type=script&lang=js"
export * from "./personnelManagement.vue?vue&type=script&lang=js"
import style0 from "./personnelManagement.vue?vue&type=style&index=0&id=25c87512&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports